import SvgIcn from '../../data/IconCompo';

function TagButtonZ({ label, onClick, className = '', iconL, hoverL, counter }) {
  return (
    <div className={`tagzbutton ${className}`} onClick={onClick}>
      <SvgIcn name={iconL}/>
      <span>{label}</span>
      {counter !== undefined && <span className="counter">{counter}</span>}
    </div>
  );
}

export default TagButtonZ;
